<template>
  <div>
    <!--  参与量化弹出框ß-->
    <van-popup :style="{  width: '80%' }"  v-model="$store.state.getInvite" class="dpop" closeable>
    <div class="popLh">
      <div class="d2 ">
        <div class="d3 mb20">
          <img src="../assets/img/img9.png" alt="" class="d4">
          {{ langUtil(159) }}
        </div>
<!--        <img src="../assets/img/img21.png" alt="" class="d5" @click="$router.push('/community')">-->
      </div>
      <div class="vant_content">
        <div class="invite_p">
            <p class="mb20">{{ langUtil(160) }}: <span>{{substringStr(parentAddress)}}</span></p>
            <p style="text-align: center;">{{ langUtil(161) }}</p>
        </div>
        <van-button color="linear-gradient(115.46deg, #FCE607 , #B9EC53, #E5FE58 )" class="d14" @click="onsubmit">
          {{ langUtil(158) }}
        </van-button>
      </div>
    </div>
    </van-popup>
  </div>
</template>

<script>
import {showTotalData} from "../tools/index"
import {Toast} from 'vant';
import {
  depositPool2,
  contractAbiAllowance,
  contractAbiApprove,
  getCommissionRelationshipParent,
  bindParentAddress,
  getCommissionRelationshipChildren
} from "../tools/chain";
import {contractAddress} from "../config";
import {
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub,
  substringStr,
  substringStr1
} from "../tools/indexFun";
import store from "../store";

export default {
  name: "getInvite",
  data() {
    return {
      tabsIndex: 0,
      showChangeSelect: false,
      exange: 0,
      exangeNumber: "",
      formErrMsg: {
        exangeNumber: ''
      },
      exangeNumber1: "",
      formErrMsg1: {
        exangeNumber: ''
      },
      buttonIndex: 0,
      buttonIndexNumber: [
        {key: 0,value: 0,num: 1},
        {key: 1,value: 200,num: 1},
        {key: 2,value: 200,num: 1},
        {key: 3,value: 150,num: 1},
      ],
      parentAddress: '',
      childrenAddress: [],
    }
  },
  mounted() {
    this.initA()
  },
  methods: {
    async initA(){
      let parentAddress = window.sessionStorage.getItem('parentAddress') || "0x0000000000000000000000000000000000000000";
      this.parentAddress = parentAddress;
      let parentA = await getCommissionRelationshipParent(this.$store.state.accounts[0])
      console.log('parentA',parentA,parentAddress)
      if (this.parentAddress.toLowerCase() !== '0x0000000000000000000000000000000000000000' && parentA.toLowerCase() === '0x0000000000000000000000000000000000000000') {
        setTimeout(()=>{
          if (this.$store.state.getInvite1<=0) {
            this.$store.commit('setState', {
              getInvite: true
            })
          }
          this.$store.commit('setState', {
            getInvite1: 1
          })
        },500)
      }
      this.childrenAddress = await getCommissionRelationshipChildren(1,200,this.$store.state.accounts[0]);
    },
    showTotalData(data) {
      return showTotalData(data)
    },
    BigNumberStr(num1,num2,col){
      return BigNumberStr(num1,num2,col);
    },
    BigNumberDiv(num1,num2,col){
      return BigNumberDiv(num1,num2,col);
    },
    BigNumberSub(num1,num2,col){
      return BigNumberSub(num1,num2,col);
    },
    substringStr(str = "", chars = 3){
      return substringStr(str, chars)
    },
    substringStr1(str = "", chars = 10){
      return substringStr1(str, chars)
    },
    async onsubmit() {
      let bCure = false;
      try {
        if (this.parentAddress.toLowerCase() === '0x0000000000000000000000000000000000000000') {
          Toast.fail(this.langUtil(162))
          return
        }
        if (this.parentAddress.toLowerCase() === this.$store.state.accounts[0].toLowerCase()) {
          Toast.fail(this.langUtil(163))
          return
        }
        let parentA = await getCommissionRelationshipParent(this.$store.state.accounts[0])
        if (parentA.toLowerCase() !== '0x0000000000000000000000000000000000000000') {
          Toast.fail(this.langUtil(164))
          return
        }
        for(let i in this.childrenAddress){
            let addressA = this.childrenAddress[i];
            console.log('addressA',addressA)
            if (this.parentAddress.toLowerCase() === addressA.toLowerCase()) {
              Toast.fail(this.langUtil(165))
              return
            }
        }
        if (bCure) return;
        bCure = true;
        Toast({
          type: "loading",
          duration: 0,
        });
        await bindParentAddress(this.parentAddress);
        // if (!this.checkInput()) return;
        Toast.clear();
        Toast.success({
          message: this.langUtil(58),
          onClose: () => {
            bCure = false;
          }
        })
        setTimeout(()=>{
          this.$store.commit('setState', {
            getInvite: false
          })
        },500)
      }catch (e){
        bCure = false;
        // alert("sorry, Network error: " + `${this.exangeNumber}|${window.sessionStorage.getItem('parentAddress') || "0x0000000000000000000000000000000000000000"}|` + JSON.stringify(e?.message))
        Toast.clear();
        Toast({
          type: "fail",
          message: e?.message,
        });
        console.log('e',e)
      }

    },
  }
}
</script>

<style lang="less" scoped>
.popLh {
  padding: 15px 15px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.d2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;

  .d3 {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: black;
  }

  .d4 {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}

.d5 {
  width: 16px;
  height: 16px;
}

.d6 {
  background-color: black;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  width: 100%;
}

.d7 {
  display: flex;
  flex-direction: column;
}

.d8 {
  width: 38px;
  height: 38px;
}

.d9 {
  font-size: 10px;
  color: #C2C4C7;
}

.d10 {
  color: #FFFFFF;
  font-size: 16px;
  padding: 8px 0 5px;
}

.d11 {
  font-size: 12px;
  color: #BEB9B6;
}

.d12 {
  width: 16px;
  height: 18px;
  margin: 15px 0;
}

.d13 {
  width: 100%;
  font-size: 10px;
  color: black;
  font-weight: 300;
  margin-top: 16px;

  span {
    font-size: 16px;
    font-weight: 400;
    float: right;
    line-height: 0.8;
  }
}

.d14 {
  width: 100%;
  height: 36px;
  color: black !important;
  margin-top: 35px;
  font-size: 12px;
}

.van-cell {
  padding: 5px 0;
}
.tabs{
  width: 100%;
  margin: 20px 0;
  text-align: center;
  background: #FFFFFF;
  border: 1px solid #000000;
  border-radius: 12px;
  li{
    padding: 10px 15px;
    border-radius: 12px;
  }
  li.active{
    background: #E5FE58;
  }
}
.vant_content{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.select_user{
  width: 100%;
  text-align: center;
  border: 1px solid #000000;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 20px;
}
.select_user_popup{
  .d18{
    font-weight: 400;
    font-size: 14px;
    color: #161718;
    margin-bottom: 7px;
  }
  .d19{
    padding: 15px;
    background-color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  .d20{
    font-size: 10px;
    color: #000000;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    span{
      color: #989898;
      padding-top: 7px;
    }
  }
  .d21{
    font-size: 10px;
    color: #000000;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: end;
    span{
      font-size: 24px;
      font-weight: 600;
    }
  }
  .d22{
    display: flex;
    align-items: center;
  }
  .d23{
    font-weight: 600;
    font-size: 18px;
    color: black;
    display: flex;
    flex-direction: column;
    span{
      font-size: 12px;
      color: #989898;
      font-weight: 400;
      padding-top: 4px;
    }
  }
  .d24{
    padding: 13px;
    background: #FFFFFF;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
  }
  .changeColor{
    border: 1px solid #000;
  }
  .d25{
    width: 23px;
    height: 23px;
  }
  .d26{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
  }
  .d27{
    width: 39px;
    height: 39px;
    margin-bottom: 5px;
  }
  .d28{
    height: 36px;
    font-size: 12px;
    color:black ;
    border-radius: 5px;
    width: 100%;
  }
  .changeColor2{
    background-color: #B5EF4D;
    //background: linear-gradient(115.46deg, #FCE607 , #B9EC53, #E5FE58 );
  }
  .d29{
    padding-top: 20px;
  }
}

</style>
